// extracted by mini-css-extract-plugin
export default {"header":"Header_header__mtodi","header__icon":"Header_header__icon__dEAHR","header__center":"Header_header__center__YlfAQ","header__right":"Header_header__right__nRQd6"};